import { render, staticRenderFns } from "./HospedesAvulsos.vue?vue&type=template&id=69141d65&"
import script from "./HospedesAvulsos.vue?vue&type=script&lang=js&"
export * from "./HospedesAvulsos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports